import { render } from "./CreateOperationService.vue?vue&type=template&id=66d38e28&scoped=true"
import script from "./CreateOperationService.vue?vue&type=script&lang=js"
export * from "./CreateOperationService.vue?vue&type=script&lang=js"

import "./CreateOperationService.vue?vue&type=style&index=0&id=66d38e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d38e28"]])

export default __exports__